module.exports = __webpack_public_path__ + "static/12-6e0b7802531bb57f31c7871e24faf12c.jpg";